<template>
  <div class="creatEditor">
    <Header style="height: 40px" notOut></Header>
    <span class="el-icon-arrow-left goback" @click="goback">返回</span>

    <div class="creatEditor_bg" v-loading="loading">
      <el-form class="creatEditor_opt" :rules="rules" ref="formInline" :inline="true" :model="formInline" size="mini">
        <el-form-item label="标题" prop="imageTextName">
          <el-input v-model="formInline.imageTextName" size="mini" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="categoryId" v-if="resourcesFrom === '1'">
          <el-select
            size="mini"
            v-model="formInline.categoryId"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 书证融通 + 产品模式  -->
        <el-form-item label=" 科目:" prop="subjectId" v-if="productFlag == 1 && courseModel == 2 ">
          <el-select v-model="formInline.subjectId" @change="subjectChange" >
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源库分类" prop="materialId" v-if="courseModel != 1">
          <el-cascader
            size="mini"
            placeholder="全部"
            :options="cascaderOptions"
            v-model="formInline.materialId"
            :props="{
              emitPath: false,
              label: 'name',
              value: 'id',
            }"
            filterable
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <!--      <officeReEdit style="height: calc(100% - 63px);"></officeReEdit>-->
      <add-mixed-mode
        :style="{height: `calc(100% - ${formHeight}px)`}"
        v-model="imageText"
        :subjectId="formInline.subjectId"
        :courseId="courseId"
        :questionId="questionId"
        @questionIdChange="questionIdChange"
      ></add-mixed-mode>
    </div>

    <div class="creatEditor_footer">
      <!--      <span class=" qingchu" @click="clreaList"><img src="../../../static/images/newCourseImages/qingchu.png" alt=""> 清 空</span>-->
      <!--      <span class="zl_button zl_whiteButton" style="margin: 0 8px">预 览</span>-->
      <span class="foldedList" @click="foldedList">一键收起</span>
      <span class="zl_button zl_blueButton" @click="handleSaveText('formInline')">保 存</span>
    </div>
  </div>
</template>

<script>
  import addMixedMode from "../single_resource_course/components/addMixedMode";
  import * as api from "../../api/sourceApi";
  import * as courseApi from "../../api/courseApi";
  import * as newCourseApi from "../../api/newCourseApi";
  import ipynb from '@/components/js/ipynb.js'
  import Header from '../../components/header/new-header';
  import officeReEdit from '../../components/officeReEdit'

  export default {
    name: "creatEditor",
    components: {
      addMixedMode, Header, officeReEdit
    },
    data() {
      return {
        loading: false,
        imageText: [],
        subjectId: this.$route.query.subjectId || sessionStorage.getItem('defaultSubjectIdForCourse'),
        courseId: this.$route.query.courseId,
        id: this.$route.query.id,
        resourceId: this.$route.query.resourceId,
        resourcesFrom: this.$route.query.resourcesFrom || '1', // 1课程资源  2 总资源库
        categoryList: [],
        cascaderOptions: [],
        formInline: {
          imageTextName: "", // 标题
          categoryId: "", // 分类
          materialId: '', //  知识点
        },
        rules: {
          imageTextName: [
            {required: true, message: '请输入标题', trigger: 'blur'},
          ],
          categoryId: [
            {required: true, message: '请选择分类', trigger: 'change'}
          ],
          materialId: [
            {required: true, message: '请选择资源库分类', trigger: 'change'}
          ],
        },
        //
        imgUrl: "../../../static/images/hed0.png",
        name: sessionStorage.getItem("loginName"),
        //
        ipynb: ipynb,
        cellsCode: {
          "cell_type": "code",
          "execution_count": null,
          "metadata": {
            "collapsed": true
          },
          "outputs": [],
          "source": []
        },
        ipynbFileId: null,
        //
        questionId: '', // 给图文内绑定一个试题。 试题ID
        courseModel: this.$route.query.courseModel, // 产品模式 1标准 2产品
        subjectList: sessionStorage.getItem('subjectListForCourse') ? JSON.parse(sessionStorage.getItem('subjectListForCourse')) : [],
        productFlag: sessionStorage.getItem("productFlag"), // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务, 5、新真实任务
        formHeight: 0,
      };
    },
    // watch: {
    //   data: {
    //     handler(val) {
    //       this.currentValue = val;
    //     },
    //     immediate: true,
    //     deep: true,
    //   }
    // },
    created() {
      this.loading = true;
      if (this.resourcesFrom === '1') {  // 课程资源里富文本的详情
        if (this.id) {
          // previewSource
          this.categoryResourceFindById();
          this.getResourceQuestion();
          this.getCodersLog();
        } else {
          this.formInline.subjectId = this.subjectId ? Number(this.subjectId) : '';
          this.getMaterialTreeListById() // 根据科目查询 资源库分类
        }
        this.findResCategoryByCourseId();
      } else if (this.resourcesFrom === '2') { // 总资源库 里富文本的详情
        this.getMaterialDetail()
      }
      // this.getMaterialTreeListById();
    },
    mounted() {
      this.formHeight = document.querySelector('.creatEditor_opt').clientHeight;
    },
    methods: {
      subjectChange() {
        this.formInline.materialId = '';
        this.getMaterialTreeListById()
      },
      // 根据资源id查询资源详情
      categoryResourceFindById() {
        newCourseApi
          .CategoryResourceFindById({
            id: this.id
          })
          .then((res) => {
            if (res.code == "0") {

              if (res.data.imageText) {
                this.imageText = JSON.parse(res.data.imageText);
              } else {
                this.imageText = [];
              }
              this.formInline.imageTextName = res.data.resourceName;
              this.formInline.categoryId = res.data.categoryId;
              this.formInline.materialId = res.data.materialsIds[0];
              this.formInline.subjectId = res.data.subjectId;
              this.getMaterialTreeListById(); // 根据科目查询 资源库分类

              this.getCodersLog();
              this.loading = false;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // 总资源库中获取资源详情
      getMaterialDetail(){
        api
          .getMaterialDetail({
            id: this.id
          })
          .then((res) => {
            if (res.code == "0") {

              if (res.data.imageText) {
                this.imageText = JSON.parse(res.data.imageText);
              } else {
                this.imageText = [];
              }
              this.formInline.imageTextName = res.data.name;
              this.formInline.materialId = res.data.materialId;
              //
              this.getCodersLog();
              this.loading = false;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      getResourceQuestion() {
        api.getResourceQuestion(this.resourceId).then(res => {
          if (res.code == "0") {
            if (res.data && res.data.questionId) {
              this.questionId = res.data.questionId
            } else {
              this.questionId = ''
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      handleSaveText(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            if (!this.imageText.length) {
              return this.$messageWarning("请编辑内容");
            }
            let bool = this.imageText.filter(item => {
              return item.extendOption.allCode
            });
            let params = {
              categoryId: this.formInline.categoryId,
              imageTextContent: JSON.stringify(this.imageText),
              imageTextName: this.formInline.imageTextName,
              isShared: 0, //0 非共享资源 1 共享资源
              subjectId: this.formInline.subjectId,
              materialId: this.formInline.materialId,
              categoryResourceId: "",
            };
            if (this.id) {
              if (this.resourcesFrom === '1'){
                // 修改
                params["categoryResourceId"] = this.id;
                api.postUpdateImageText(params).then((res) => {
                  if (res.code == 0) {
                    if (bool.length) {
                      this.postRunCoders(this.id);
                    }
                    this.seveResourceQuestion(this.resourceId)
                    this.$router.go(-1);
                    this.$messageSuccess("保存成功");
                  }
                });
              }else if (this.resourcesFrom === '2'){
                let option = {
                  id: this.id,
                  imageText: JSON.stringify(this.imageText),
                  isCode: 1,
                  materialId: this.formInline.materialId,
                  name: this.formInline.imageTextName,
                  subjectId: this.formInline.subjectId,
                }
                api.editImageTextlDetail(option).then( res =>{
                  if (res.code == 0) {
                    this.$router.go(-1);
                    this.$messageSuccess("保存成功");
                  }
                })
              }

            } else {
              // 修改总资源库的资源
              api.postAddImageText(params).then((res) => {
                if (res.code == 0) {
                  if (res.code == 0) {
                    if (bool.length) {
                      this.postRunCoders(this.id);
                    }
                    this.seveResourceQuestion(this.resourceId)
                    this.goback();
                    this.$messageSuccess("保存成功");
                  }
                }
              });
            }

          } else {
            return false;
          }
        });


      },
      questionIdChange(val) {
        this.questionId = val;
      },
      seveResourceQuestion(id) {
        let params = {
          "resourceId": id,
          "questionId": this.questionId
        }
        api.editResourceQuestion(params)
      },
      getCodersLog() {
        let param = {
          "targetId": this.id,
          "targetType": 1,
        }
        courseApi.getCodersLog(param).then(res => {
          if (res.code == 0) {
            if (res.data.length) {
              this.ipynbFileId = res.data[0].id;
            }
          }
        })
      },
      postRunCoders(id) {
        let cells = this.ipynb.cells;
        cells[0].source = ['## ' + this.formInline.imageTextName];
        [].forEach.call(this.imageText, item => {
          if (item.type == 11) {
            let code = JSON.parse(JSON.stringify(this.cellsCode));
            code.source = item.value ? item.value.split("\n").map((c) => c + "\n") : [];
            code.outputs = [];
            cells.push(code);
          }
        })
        let param = {
          "targetId": id,
          "targetType": 1,
          "dataType": 1,
          "contentType": 1,
          "content": JSON.stringify(ipynb),
          "fileName": this.formInline.imageTextName,
          "id": this.ipynbFileId,
        }
        courseApi.postRunCoders(param).then(() => {
        })
      },

      clreaList() {
        this.imageText = [];
      },

      foldedList() {
        [].forEach.call(this.imageText, item => {
          this.$set(item, 'show', true)
        })
      },
      // 资源库分类
      getMaterialTreeListById() {
        this.cascaderOptions = [];
        if (!this.subjectId) {
          this.loading = false;
          return
        }
        api.getMaterialTreeListById(this.formInline.subjectId).then((res) => {
          if (res.code == 0) {
            this.cascaderOptions = this.getTreeData(res.data.materials);
            this.loading = false;
          }
        });
      },
      /**
       * 解决el-cascader控件 最后一级暂无数据仍然显示。
       * @param data
       * @returns {Array}
       */
      getTreeData(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children.length < 1) {
            // child若为空数组，则将child设为undefined
            data[i].children = undefined;
          } else {
            // child若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        }
        return data;
      },
      // 上传查询资源分类
      findResCategoryByCourseId() {
        this.categoryList = {};
        api
          .FindResCategoryByCourseId(this.courseId)
          .then((res) => {
            if (res.code == "0") {
              this.categoryList = res.data;
              if (!this.id) { // 新建默认其他
                this.formInline.categoryId = this.categoryList.find(item => item.categoryName === "其它") ? this.categoryList.find(item => item.categoryName === "其它").id : ''; // 默认 其它
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      goback() {
        if (this.$route.query.from === '_blank') { // 新开页富文本 返回到素材
          this.$router.push({
           path: "/courseEditPage",
            query: {
              ...JSON.parse(this.$AES.AES_Decrypt(this.$route.query.query)),
              curId: 2,
            }
          })
        } else {
          this.$router.go(-1);
        }
      },
      handleCommand(command) {
        if (command == "logOut") {
          this.$logOut();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .creatEditor {
    width: 100%;
    height: 100%;
    background: #f5f5f7;
    display: flex;
    flex-direction: column;
    position: relative;

    .goback {
      cursor: pointer;
      position: absolute;
      font-weight: 600;
      top: 60px;
      left: 20px;
      font-size: 14px;
    }

    .creatEditor_header {
      height: 44px;
      background: #04194b;
      text-align: center;
      line-height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;

      .creatEditor_header_title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }

      .zl-header-img {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        display: inline-block;
      }
    }

    .creatEditor_goback {
      height: 40px;
      background: #ffffff;
      box-shadow: 1px 0px 11px 0px rgba(172, 172, 172, 0.22);
      border-radius: 4px;
      padding: 0 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .goback {
        font-size: 12px;
        cursor: pointer;
      }
    }

    .creatEditor_bg {
      flex: 1;
      width: 1200px;
      margin: 15px auto;
      background: #F7F7FC;
      /*background: rgba(237, 237, 240, 0.36);*/
      box-shadow: 1px 0px 11px 0px rgba(172, 172, 172, 0.22);
      border-radius: 4px;
      overflow: hidden;

      .creatEditor_opt {
        padding: 15px 50px 0;

        /deep/ .el-form-item__label {
          font-size: 12px;
        }
      }
    }

    .login-user {
      position: relative;
      cursor: pointer;
      margin-right: 32px;

      .login-name {
        margin-left: 6px;
        color: #ffffff;
        line-height: 20px;
      }

      .user-name {
        height: 64px;
        display: flex;
        align-items: center;

        .imgBox {
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #333;
          border-radius: 50%;

          img {
            height: 100%;
          }
        }
      }

      &:hover {
        .login-name {
          opacity: 0.8;
        }
      }
    }

    .creatEditor_footer {
      position: absolute;
      top: 0px;
      right: 20px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      display: flex;
      align-items: center;

      .qingchu, .foldedList {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        padding: 0 15px;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/new_course_editor/creatEditor.vue